import React, {useEffect, useState} from 'react';
import _ from "lodash";
import {searchPrintfulCategoriesWithSearchCriteria} from "../../services/printful-categories-data.service";
import ShowEmptyListMessage from "../../../design/components/common/show-empty-list-message";
import {PRINTFUL_CATEGORIES_FIELDS_LIST} from "../../constants/printful-categories.constant";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";
import {getSinglePrintfulInfo} from "../../services/printful-info-data.service";
import {PRINTFUL_INFO_IDS} from "../../constants/printful-info.constant";
import {syncPrintfulCategories, syncShopifyProducts} from "../../../common/services/cloud-function-service";
import ProductImageSmall from "../../../pod/components/product-upload/product-image-small";

const defaultFilterCriteria: any = {};

const PrintfulCategoriesList = () => {
    const [printfulCategoriesList, setPrintfulCategoriesList] = useState(null);
    const [prntfulCategoriesInfo, setPrintfulCategoriesInfo] = useState(null);
    const [filterCriteria, setFilterCriteria] = useState(defaultFilterCriteria);
    const [dataFetchInProgress, setDataFetchInProgress] = useState(true);

    const getPrintfulCategoriesList = async () => {
        setDataFetchInProgress(true);

        const printfulCategoriesInfoResult = await getSinglePrintfulInfo(PRINTFUL_INFO_IDS.PRINTFUL_CATEGORIES);
        printfulCategoriesInfoResult.categories = _.orderBy(printfulCategoriesInfoResult?.categories, ['parent_id', 'catalog_position', 'parent', 'title'], ['asc', 'asc', 'asc', 'asc']);

        console.log('printfulCategoriesInfoResult', printfulCategoriesInfoResult)

        setPrintfulCategoriesInfo(printfulCategoriesInfoResult);
        setPrintfulCategoriesList(printfulCategoriesInfoResult?.categories);
        setDataFetchInProgress(false);
    }

    useEffect(() => {
        getPrintfulCategoriesList();
    }, [filterCriteria]);

    const refreshPrintfulCategoriesList = async () => {
        await getPrintfulCategoriesList();
    }

    const startPrintfulCategoriesSyncProcess = async () => {
        setDataFetchInProgress(true);
        await syncPrintfulCategories();

        await refreshPrintfulCategoriesList();
        setDataFetchInProgress(false);
    }

    return (
        <>

            <div className="flex justify-between">

                <div className="flex justify-start items-center mt-2 -ml-2 mb-2 w-full">
                    <div className={'text-xl ml-2'}>
                        Categories
                        {prntfulCategoriesInfo &&
                            <span className={'ml-2'}>({prntfulCategoriesInfo?.total})</span>
                        }
                    </div>

                    {/*<PrintfulCategoriesFilters
                        filterCriteria={filterCriteria}
                        setFilterCriteria={setFilterCriteria}/>*/}

                    <div className="ml-4">
                        <ShowProgressSpinner dataFetchInProgress={dataFetchInProgress}/>
                    </div>
                </div>

                <div className="text-center w-1/3 flex items-center justify-end">
                    <div>
                        <button
                            className="button-green px-4 py-2 flex items-center justify-center"
                            onClick={startPrintfulCategoriesSyncProcess}>
                            <span>Sync Categories</span>
                        </button>
                    </div>
                </div>

            </div>

            <div className="flex justify-start">

                <div
                    className="w-full bg-white rounded-lg mt-4">

                    <ShowEmptyListMessage
                        dataList={printfulCategoriesList}
                        dataFetchInProgress={dataFetchInProgress}
                        label={'Printful Categories'}/>

                    {printfulCategoriesList?.length > 0 &&
                        <table className="w-full">
                            <thead className="">
                            <tr>
                                <th className="p-2 border border-gray-400 bg-gray-400 text-white w-12">S.No</th>
                                {PRINTFUL_CATEGORIES_FIELDS_LIST?.map((printfulCategoriesField, rowIndex) => (
                                    <th key={`th-${rowIndex}`}
                                        className={`p-2 border border-gray-400 bg-gray-400 text-white text-left pl-2 ${printfulCategoriesField?.cssClass}`}>{printfulCategoriesField?.label}</th>
                                ))}
                                <th className="p-2 border border-gray-400 bg-gray-400 text-white">
                                    Actions
                                </th>
                            </tr>
                            </thead>
                            <tbody className="">
                            {prntfulCategoriesInfo?.categories?.map((printfulCategories, rowIndex) => (
                                <tr key={`row-${rowIndex}`} className="border border-gray-400">
                                    <td className="p-2 border border-gray-400 m-auto">
                                        <div className="flex justify-center w-12">
                                            {rowIndex + 1}
                                        </div>
                                    </td>

                                    {PRINTFUL_CATEGORIES_FIELDS_LIST?.map((printfulCategoriesField, columnIndex) => (
                                        <React.Fragment key={`column-${rowIndex}-${columnIndex}`}>
                                            <td className={`p-2 border border-gray-400 m-auto ${printfulCategoriesField?.cssClass}`}>
                                                {printfulCategoriesField?.optionsMap &&
                                                    <>{printfulCategoriesField?.optionsMap[printfulCategories[printfulCategoriesField?.attribute]]?.name}</>
                                                }

                                                {!printfulCategoriesField?.optionsMap && printfulCategoriesField?.type !== 'image' &&
                                                    <>
                                                        {printfulCategories[printfulCategoriesField?.attribute]}

                                                        {printfulCategoriesField?.secondaryAttribute &&
                                                            <div className={'text-gray-500 text-sm'}>
                                                                {printfulCategories[printfulCategoriesField?.secondaryAttribute]}
                                                            </div>
                                                        }
                                                    </>
                                                }

                                                {printfulCategoriesField?.type === 'image' &&
                                                    <div>
                                                        <ProductImageSmall
                                                            imageUrl={printfulCategories[printfulCategoriesField?.attribute]}/>
                                                    </div>
                                                }
                                            </td>
                                        </React.Fragment>
                                    ))}

                                    <td className="p-2 border border-gray-400 m-auto w-40">
                                        <div className="flex justify-center">

                                        </div>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    }
                </div>

            </div>

        </>
    )
}

export default PrintfulCategoriesList
